import {BlockComponentProps} from 'Event/Marketplace/Block'
import {PurchaseFormBlock} from 'Event/Marketplace/Block/PurchaseForm'
import FontSelect from 'lib/FontSelect'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import MarginPaddingInputs from 'lib/ui/MarginPaddingInputs'
import Slider from 'lib/ui/Slider'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import {useConfigurableSection} from 'organization/Marketplace/config/ConfigurableSection'
import React from 'react'
import {Controller} from 'react-hook-form'

interface SectionLabelConfigProps
  extends PurchaseFormBlock,
    BlockComponentProps {
  children: string
  inputName: string
}

export default function SectionLabelConfig(props: SectionLabelConfigProps) {
  const {id, inputName} = props
  const {sectionId, update} = useConfigurableSection()

  const save = (data: any) => {
    update(data.sections[sectionId])
  }

  const {
    form: {control, register},
  } = useConfig()

  return (
    <Config title="Section Label" onSave={save}>
      <SettingsPanel>
        <CollapsibleSection
          label="Label"
          noDivider
          storageKey={`blocks-${id}-styling.inputFields.placeholderText`}
        >
          <TextField
            name={`sections.${sectionId}.blocks.${id}.${inputName}`}
            defaultValue={props.children}
            label="Label"
            inputProps={{
              'aria-label': 'label',
              ref: register,
            }}
          />
        </CollapsibleSection>
      </SettingsPanel>

      <StylingPanel>
        <CollapsibleSection
          label="Font"
          noDivider
          storageKey={`blocks-${id}-styling.sectionLabel.fontSize`}
        >
          <Controller
            control={control}
            name={`sections.${sectionId}.blocks.${id}.sectionLabel.font`}
            defaultValue={props.sectionLabel?.font}
            render={({value, onChange}) => (
              <FontSelect value={value} onChange={onChange} />
            )}
          />
          <Controller
            name={`sections.${sectionId}.blocks.${id}.sectionLabel.fontSize`}
            defaultValue={props.sectionLabel?.fontSize ?? 18}
            control={control}
            render={({value, onChange}) => (
              <Slider
                min={10}
                max={100}
                step={1}
                onChange={onChange}
                value={value}
              />
            )}
          />
        </CollapsibleSection>

        <CollapsibleSection
          label="Spacing"
          noDivider
          storageKey={`blocks-${id}-styling.sectionLabel.spacing`}
        >
          <MarginPaddingInputs
            control={control}
            namePrefix={`sections.${sectionId}.blocks.${id}.sectionLabel.margin`}
            values={
              props.sectionLabel?.margin ?? {
                top: 16,
                right: 0,
                bottom: 16,
                left: 0,
              }
            }
          />
        </CollapsibleSection>
      </StylingPanel>
    </Config>
  )
}
